export class CustomModal {
    constructor() {
        this.element = $('#custom-modal');
    }
    show(title = '', content = '') {
        this.setTitle(title);
        this.setContent(content);

        this.element.modal('show');
    }
    close() {
        this.element.modal('hide');
    }
    setTitle(title = '') {
        if (title === false) {
            return;
        }

        this.element.find('.js-title').html(title);
    }
    setContent(content = '') {
        if (content === false) {
            return;
        }

        this.element.find('.js-content').html(content);
    }
    bind(event, callback) {
        this.element.off(event).on(event, callback);
    }
}
